import React, { useEffect, useState, useContext, useCallback } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { auth } from './utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { SettingsContext } from './contexts/settings-provider';

import SignIn from './pages/SignIn/SignIn';
import Frontpage from './pages/Frontpage/Frontpage';
import Game from './pages/Game/Game';
import Profile from './pages/Profile/Profile';
import Loading from './components/Loading/Loading';
import Wipe from './components/Wipe/Wipe';
import Score from './pages/Score/Score';
import Winner from './pages/Winner/Winner';

const App = () => {
  const [settings, dispatch] = useContext(SettingsContext);

  useEffect(() => {
    const unsubsrcibe = onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch({
          type: 'update_settings',
          payload: { key: 'user', value: user },
        });
      } else {
        dispatch({
          type: 'update_settings',
          payload: { key: 'user', value: false },
        });
      }
    });
    return () => {
      unsubsrcibe();
    };
  }, [settings.user, dispatch]);

  return (
    <BrowserRouter>
      <Routing />
    </BrowserRouter>
  );
};

const Routing = () => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransistionStage] = useState('open');

  // Animations
  useEffect(() => {
    if (location !== displayLocation) setTransistionStage('close');
  }, [location, displayLocation]);

  const onAnimationEnd = useCallback(() => {
    if (transitionStage === 'close') {
      setTransistionStage('open');
      setDisplayLocation(location);
    }
  }, [location, transitionStage]);

  return (
    <>
      <Routes location={displayLocation}>
        <Route
          path="/play"
          element={
            <AuthValidation>
              <Game />
            </AuthValidation>
          }
        />
        <Route
          path="/profile"
          element={
            <AuthValidation>
              <Profile />
            </AuthValidation>
          }
        />
        <Route path="/score" element={<Score />} />
        <Route
          path="/winner"
          element={
            <AuthValidation>
              <Winner />
            </AuthValidation>
          }
        />
        <Route path="/" element={<Frontpage />} />
      </Routes>
      <Wipe stage={transitionStage} onEnd={onAnimationEnd} />
    </>
  );
};

const AuthValidation = ({ children }) => {
  const [signedIn, setSignedIn] = useState(null);

  useEffect(() => {
    const unsubsrcibe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setSignedIn(true);
      } else {
        setSignedIn(false);
      }
    });
    return () => {
      unsubsrcibe();
    };
  }, []);

  if (signedIn === true) {
    return children;
  } else if (signedIn === false) {
    return <SignIn />;
  } else {
    return <Loading />;
  }
};

export default App;
